import { render } from "./sign-petition.vue?vue&type=template&id=c6f6ab56"
import script from "./sign-petition.vue?vue&type=script&lang=js"
export * from "./sign-petition.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__